const topics = [
  {
    title: '热血少年漫专题',
    desc: '燃爆全场的战斗番合集',
    tag: '热血',
    count: '326部',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20anime%20scene%20with%20fierce%20battle%20poses%2C%20vibrant%20energy%20effects%20in%20warm%20orange%20and%20red%20tones%2C%20comic%20style%20speed%20lines%2C%20dramatic%20lighting%20on%20illustrated%20warrior%20characters%2C%20Japanese%20shonen%20manga%20aesthetic%2C%20clean%20cream%20background%20with%20subtle%20gradient%2C%20epic%20atmosphere&width=600&height=400&seq=51anime-index-01&orientation=landscape',
  },
  {
    title: '治愈系日常番精选',
    desc: '温暖人心的慢生活动漫',
    tag: '治愈',
    count: '218部',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20slice%20of%20life%20anime%20scene%20with%20cozy%20countryside%20setting%2C%20soft%20pastel%20warm%20lighting%2C%20gentle%20illustrated%20characters%20enjoying%20tea%20and%20nature%2C%20fluffy%20clouds%20and%20green%20fields%2C%20healing%20iyashikei%20atmosphere%2C%20cream%20and%20soft%20green%20palette%2C%20clean%20minimal%20composition&width=600&height=400&seq=51anime-index-02&orientation=landscape',
  },
  {
    title: '悬疑推理漫剧场',
    desc: '烧脑反转的智斗故事',
    tag: '悬疑',
    count: '189部',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20anime%20scene%20with%20dramatic%20shadow%20play%2C%20silhouetted%20figure%20under%20streetlamp%20in%20rain%2C%20film%20noir%20inspired%20illustration%2C%20deep%20amber%20and%20charcoal%20tones%2C%20suspenseful%20atmosphere%2C%20clean%20minimal%20background%2C%20Japanese%20mystery%20manga%20style&width=600&height=400&seq=51anime-index-03&orientation=landscape',
  },
  {
    title: '国漫崛起精选集',
    desc: '优质国产动漫一次看够',
    tag: '国漫',
    count: '402部',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20Chinese%20donghua%20animation%20style%20scene%20with%20traditional%20ink%20wash%20aesthetic%2C%20flowing%20robes%20and%20ancient%20architecture%2C%20dramatic%20mountain%20landscape%2C%20warm%20golden%20and%20coral%20accents%2C%20modern%20Chinese%20animation%20art%2C%20clean%20cream%20background&width=600&height=400&seq=51anime-index-04&orientation=landscape',
  },
  {
    title: '恋爱喜剧物语',
    desc: '甜到掉牙的浪漫番合集',
    tag: '恋爱',
    count: '275部',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20scene%20with%20cherry%20blossom%20petals%20dancing%20in%20spring%20breeze%2C%20two%20illustrated%20characters%20sharing%20a%20tender%20moment%20under%20sakura%20tree%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20dreamy%20bokeh%20effect%2C%20shojo%20manga%20aesthetic&width=600&height=400&seq=51anime-index-05&orientation=landscape',
  },
  {
    title: '奇幻异世界冒险',
    desc: '穿越次元的幻想之旅',
    tag: '奇幻',
    count: '310部',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20isekai%20anime%20scene%20with%20magical%20portal%20glowing%20in%20ancient%20ruins%2C%20adventurers%20with%20swords%20and%20magic%20staffs%2C%20floating%20crystals%20and%20sparkles%2C%20warm%20golden%20ethereal%20light%2C%20rich%20amber%20and%20cream%20tones%2C%20epic%20fantasy%20atmosphere&width=600&height=400&seq=51anime-index-06&orientation=landscape',
  },
  {
    title: '科幻机甲编年史',
    desc: '硬核机械与未来幻想',
    tag: '科幻',
    count: '156部',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20mecha%20anime%20scene%20with%20giant%20robot%20standing%20in%20neon-lit%20cityscape%2C%20detailed%20mechanical%20designs%2C%20warm%20amber%20and%20steel%20gray%20color%20scheme%2C%20sci-fi%20atmosphere%2C%20anime%20illustration%20style%2C%20clean%20composition%20with%20dramatic%20perspective&width=600&height=400&seq=51anime-index-07&orientation=landscape',
  },
  {
    title: '校园青春物语',
    desc: '教室里的青春记忆',
    tag: '校园',
    count: '243部',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20high%20school%20anime%20scene%20with%20sunlit%20classroom%2C%20cherry%20blossoms%20outside%20window%2C%20illustrated%20students%20in%20school%20uniforms%2C%20warm%20afternoon%20light%2C%20nostalgic%20youthful%20atmosphere%2C%20soft%20cream%20and%20coral%20color%20palette%2C%20slice%20of%20life%20aesthetic&width=600&height=400&seq=51anime-index-08&orientation=landscape',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门专题合集</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按类型精心分类，快速找到您感兴趣的动漫专题，持续更新中
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {topics.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs rounded-full font-medium">{item.tag}</span>
                  <span className="text-xs text-foreground-400">{item.count}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}